module.exports = __webpack_public_path__ + "dc3e3dd371887063d75b25c21e2d190f.gif";


//////////////////
// WEBPACK FOOTER
// ./assets/images/misc/student-login-clever.gif
// module id = 1054
// module chunks = 0